var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { createRoot } from "react-dom/client";
import { FacetecApp } from "./app/react-ts-sample";
import { ProgressStepper, ENROLL_STEPS, VERIFICATION_STEPS } from "./components/ProgressStepper";
var container = document.getElementById("app");
var root = createRoot(container);
var BasicComponent = /** @class */ (function (_super) {
    __extends(BasicComponent, _super);
    function BasicComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showModal: false,
            modalType: null,
            showStepper: false,
            currentStep: 1,
            steps: []
        };
        _this.handleStartSession = function () {
            _this.setState({ showModal: false });
            if (_this.state.modalType === 'verification') {
                _this.onLivenessCheckPressed();
            }
            else if (_this.state.modalType === 'enroll') {
                _this.onEnrollUserPressed();
            }
        };
        _this.handleCancelSession = function () {
            _this.setState({ showModal: false, modalType: null });
        };
        return _this;
    }
    BasicComponent.prototype.onLivenessCheckPressed = function () {
        FacetecApp.onLivenessCheckPressed();
    };
    BasicComponent.prototype.onEnrollUserPressed = function () {
        FacetecApp.onEnrollUserPressed();
    };
    BasicComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.ejecutarAccionSegunRuta();
        window.updateStepperProgress = function (step) {
            _this.setState({ currentStep: step });
        };
        window.showStepper = function (type) {
            _this.setState({
                showStepper: true,
                currentStep: 1,
                steps: type === 'enroll' ? ENROLL_STEPS : VERIFICATION_STEPS
            });
        };
        window.hideStepper = function () {
            _this.setState({ showStepper: false });
        };
    };
    BasicComponent.prototype.ejecutarAccionSegunRuta = function () {
        var _this = this;
        var rutaNormalizada = window.location.pathname.replace(/\/+$/, "").toLowerCase();
        var terminaCon = function (valor) {
            return rutaNormalizada.length >= valor.length && rutaNormalizada.lastIndexOf(valor) === (rutaNormalizada.length - valor.length);
        };
        // Verificar si viene parámetro auto=true para iniciar directamente
        var urlParams = new URLSearchParams(window.location.search);
        var autoStart = urlParams.get('auto') === 'true';
        if (terminaCon("/verification")) {
            FacetecApp.runAfterInitialization(function () {
                if (autoStart) {
                    // Auto-iniciar verificación sin modal
                    _this.onLivenessCheckPressed();
                }
                else {
                    // Mostrar modal (flujo anterior comentado para usar solo auto-inicio)
                    // this.setState({ showModal: true, modalType: 'verification' });
                    console.log('⚠️ Se requiere parámetro auto=true para iniciar');
                }
            });
            return;
        }
        if (terminaCon("/enroll")) {
            FacetecApp.runAfterInitialization(function () {
                if (autoStart) {
                    // Auto-iniciar enrollment sin modal
                    _this.onEnrollUserPressed();
                }
                else {
                    // Mostrar modal (flujo anterior comentado para usar solo auto-inicio)
                    // this.setState({ showModal: true, modalType: 'enroll' });
                    console.log('⚠️ Se requiere parámetro auto=true para iniciar');
                }
            });
        }
    };
    BasicComponent.prototype.render = function () {
        var _a = this.state, showModal = _a.showModal, modalType = _a.modalType, showStepper = _a.showStepper, currentStep = _a.currentStep, steps = _a.steps;
        return (React.createElement("div", null,
            showStepper && (React.createElement(ProgressStepper, { currentStep: currentStep, steps: steps })),
            React.createElement("div", { className: "wrapping-box-container" },
                React.createElement("div", { id: "controls", className: "controls" },
                    React.createElement("p", { id: "status" }, "Initializing...")),
                React.createElement("div", { id: "custom-logo-container" },
                    React.createElement("img", { id: "facetec-logo", src: "../images/facetec_logo.png" })))));
    };
    return BasicComponent;
}(React.Component));
export default BasicComponent;
root.render((React.createElement(BasicComponent, { tab: "home" })));
